import React from 'react';
import { categories, type CategoryId } from '../types';

interface CategoryFilterProps {
  selected: CategoryId;
  onSelect: (category: CategoryId) => void;
}

export function CategoryFilter({ selected, onSelect }: CategoryFilterProps) {
  return (
    <div className="relative max-w-7xl mx-auto mb-8 sm:mb-12">
      <div className="flex flex-row md:flex md:justify-center gap-2 md:gap-4 overflow-x-auto md:overflow-visible pb-4 px-4 sm:px-6 scrollbar-hide snap-x snap-mandatory md:snap-none scroll-smooth">
        {categories.map(({ id, name, icon: Icon, description }) => {
          const isSelected = selected === id;
          return (
            <button
              key={id}
              onClick={() => onSelect(id)}
              className={`
                group relative flex flex-col items-center justify-center gap-1 md:gap-3
                px-3 py-3 md:px-6 md:py-6 rounded-xl md:rounded-2xl transition-all duration-300
                min-w-[80px] md:min-w-[140px] h-[70px] md:h-[120px] 
                flex-shrink-0 md:flex-shrink
                snap-start md:snap-align-none hover:scale-105
                ${isSelected
                  ? 'bg-gradient-to-br from-primary-500 to-blue-600 text-white shadow-2xl shadow-primary-500/25 scale-105'
                  : 'bg-white text-gray-600 hover:bg-gray-50 hover:shadow-xl border border-gray-200 hover:border-gray-300'
                }
              `}
              title={description}
            >
              {/* Background glow for selected */}
              {isSelected && (
                <div className="absolute inset-0 bg-gradient-to-br from-primary-400 to-blue-500 rounded-xl md:rounded-2xl blur-xl opacity-60 -z-10"></div>
              )}
              
              <div className={`
                flex items-center justify-center
                w-6 h-6 md:w-10 md:h-10 rounded-lg md:rounded-xl transition-all duration-300
                ${isSelected 
                  ? 'bg-white/20 text-white' 
                  : 'bg-gray-100 text-gray-600 group-hover:bg-primary-100 group-hover:text-primary-600'
                }
              `}>
                <Icon className="w-3 h-3 md:w-6 md:h-6" />
              </div>
              
              <span className={`
                text-[10px] md:text-sm font-semibold text-center leading-tight
                ${isSelected ? 'text-white' : 'text-gray-700 group-hover:text-gray-900'}
              `}>
                {name}
              </span>

              {/* Selection indicator */}
              {isSelected && (
                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 md:w-2 md:h-2 bg-white rounded-full"></div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}